import { render, staticRenderFns } from "./DeleteType.vue?vue&type=template&id=7b5101ba&scoped=true"
import script from "./DeleteType.vue?vue&type=script&lang=js"
export * from "./DeleteType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5101ba",
  null
  
)

export default component.exports